import React, { useState, useRef } from 'react';
import { Check, Star, Shield, Lock, Pause, Play, XCircle, Sparkles, TrendingUp, Sunrise, Compass, Waves, HeartPulse, ChevronDown, ChevronUp, Zap, Headphones, BookHeadphones } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { AudioPlayer } from '../components/AudioPlayer';
import { Users, Globe } from 'lucide-react';
interface LandingPageProps {
  lang: 'es' | 'en';
}
export function LandingPage({
  lang
}: LandingPageProps) {
  const content = {
    es: {
      badge: 'Nuevo Manual de Consciencia',
      headline: '¿Quieres Despertar de la Matrix Sin Perderte a Ti Mismo?',
      subheadline: 'Nuevo Libro Transformador de Consciencia Revela 7 Códigos Ocultos Para Recordar Quién Eres Realmente Y Jugar El Verdadero Juego de la Vida, Comenzando Hoy',
      lead: 'Despierta a tu verdadero poder en los próximos 90 minutos usando este manual espiritual decodificado de la sabiduría antigua y la ciencia de la simulación... incluso si todavía te sientes atrapado en el miedo, la confusión o ciclos interminables de auto-mejora.',
      ctaRed: 'SÍ — ESTOY LISTO PARA JUGAR',
      ctaGold: 'ESTOY LISTO PARA RECORDAR',
      quote: 'Hay dos tipos de humanos: Los que pasan toda su vida reaccionando al tablero... y los que se dan cuenta de que son ellos quienes sostienen el control. ¿Cuál eres tú?',
      credibility: ['Confiado Por Lectores Despertando En Más de 25 Países', 'Destacado en círculos espirituales explorando consciencia, DMT, energía y el fenómeno Matrix'],
      painTitle: 'Si eres como la mayoría de los buscadores, estás cansado de sentir que falta algo.',
      painSubtitle: 'Como si nacieras para más, pero no puedes recordar qué. En este momento, probablemente estés:',
      painPoints: ['Persiguiendo el éxito pero sintiéndote vacío por dentro', "Viendo a otros 'manifestar' mientras luchas con el caos", "Abrumado por consejos de 'sanación' que nunca funcionan", 'Preguntándote por qué los mismos patrones se repiten', 'Frustrado porque sabes que la realidad es más profunda'],
      urgencyTitle: 'Estamos viviendo la mayor ventana de despertar en la historia humana.',
      urgencyText: "Cada día que sigues ejecutando el viejo programa, pierdes tiempo, energía y la oportunidad de recordar por qué viniste aquí. El sistema se alimenta de tu distracción mientras tu alma susurra: 'Despierta... tú eres el jugador.'",
      authorTitle: 'De: Gabriel Beltrán | Tierra, Densidad Nivel 3',
      authorStory: 'Una vez viví dormido dentro del sistema, trabajando, logrando, repitiendo los mismos patrones. Entonces todo se quebró. Me di cuenta de que mi vida no era aleatoria — estaba programada. Años de investigación y encuentros con el DMT descubrieron la arquitectura oculta de la realidad. Ese viaje se convirtió en ¿Estás Listo Para Jugar?',
      offerTitle: 'Edición Digital',
      priceOld: '$47',
      priceNew: '$17',
      offerFeatures: ['Acceso digital instantáneo', 'Lee en cualquier dispositivo', 'Audiolibro completo (1:49:47)'],
      bonusTitle: 'BONO GRATIS — DMT: La Molécula Espiritual',
      bonusDesc: 'Audiolibro + Libro Digital ($39.97 Valor). Descubre la molécula que une ciencia y espíritu. 92 páginas | Espiritualidad, Consciencia, Ciencia',
      packTitle: 'Pack Despertar — BEST SELLER',
      packPriceOld: '$96.94',
      packPriceNew: '$27',
      packFeatures: ['¿Estás listo para jugar? (audio + eBook) — $17', 'Meditaciones Guiadas 30 días (audio binaural) — $47', 'BONUS: DMT La Molécula de Dios (audio + eBook) — $17', 'Masterclass: "El Verdadero Secreto de los Élites" (1hr)'],
      modulesTitle: 'QUÉ OBTIENES: El Sistema Central ($47 Valor)',
      modules: ['El Velo Revelado', 'Las Reglas Ocultas Del Sistema', 'La Secuencia del Despertar', 'El Plan del Juego Infinito'],
      guaranteeTitle: 'Garantía "Recuerda Quién Eres" — 30 Días',
      guaranteeText: 'Si este libro no despierta un cambio genuino en tu consciencia dentro de 7 días, reembolso completo en 24 horas. Sin preguntas.',
      finalUrgency: 'Oferta Por Tiempo Limitado. Una vez agotada esta primera tirada, el precio vuelve a $47. La consciencia se está acelerando — el próximo ciclo no esperará.',
      path1: 'Camino 1: Seguir jugando ciego, repitiendo ciclos.',
      path2: 'Camino 2: Despertar y jugar conscientemente.',
      faq: [{
        q: '¿Para quién es esto?',
        a: 'Para quien sienta que el mundo es un juego que no entiende y quiere recordar cómo jugar.'
      }, {
        q: '¿Necesito ser "espiritual"?',
        a: 'No. Solo curiosidad y coraje de cuestionar.'
      }, {
        q: '¿Cuánto tiempo para ver resultados?',
        a: 'La mayoría siente cambio en los primeros tres capítulos.'
      }, {
        q: '¿Está conectado con la religión?',
        a: 'No. Es un marco universal: ciencia + misticismo + experiencia directa.'
      }],
      ps: 'P.D.: Tu despertar no comienza cuando terminas el libro. Comienza en el momento en que dices que sí.'
    },
    en: {
      badge: 'New Consciousness Manual',
      headline: 'Do You Want to Wake Up from the Matrix Without Losing Yourself?',
      subheadline: 'New Transformational Consciousness Book Reveals 7 Hidden Codes to Remember Who You Really Are And Play The True Game of Life, Starting Today',
      lead: 'Awaken to your true power in the next 90 minutes using this spiritual manual decoded from ancient wisdom and simulation science... even if you still feel trapped in fear, confusion, or endless self-improvement cycles.',
      ctaRed: 'YES — I AM READY TO PLAY',
      ctaGold: 'I AM READY TO REMEMBER',
      quote: 'There are two types of people: those who play as a Piece, and those who hold the Controller. Which are you?',
      credibility: ['Trusted By Readers Awakening In Over 25 Countries', 'Featured in spiritual circles exploring consciousness, DMT, energy, and the Matrix phenomenon'],
      painTitle: 'If you are like most seekers, you are tired of feeling like something is missing.',
      painSubtitle: "As if you were born for more, but can't remember what. Right now, you are probably:",
      painPoints: ['Chasing success but feeling empty inside', "Watching others 'manifest' while you struggle with chaos", "Overwhelmed by 'healing' advice that never works", 'Wondering why the same patterns repeat', 'Frustrated because you know reality is deeper'],
      urgencyTitle: 'We are living through the greatest awakening window in human history.',
      urgencyText: "Every day you continue running the old program, you lose time, energy, and the chance to remember why you came here. The system feeds on your distraction while your soul whispers: 'Wake up... you are the player.'",
      authorTitle: 'From: Gabriel Beltrán | Earth, Density Level 3',
      authorStory: "I once lived asleep within the system, working, achieving, repeating the same patterns. Then everything cracked. I realized my life wasn't random — it was programmed. Years of research and encounters with DMT uncovered the hidden architecture of reality. That journey became Are You Ready To Play?",
      offerTitle: 'Digital Edition',
      priceOld: '$47',
      priceNew: '$17',
      offerFeatures: ['Instant digital access', 'Read on any device', 'Full audiobook (1:49:47)'],
      bonusTitle: 'FREE BONUS — DMT: The Spirit Molecule',
      bonusDesc: 'Audiobook + Digital Book ($39.97 Value). Discover the molecule that bridges science and spirit. 92 pages | Spirituality, Consciousness, Science',
      packTitle: 'Awakening Pack — BEST SELLER',
      packPriceOld: '$96.94',
      packPriceNew: '$27',
      packFeatures: ['Are You Ready To Play? (audio + eBook) — $17', '30 Days Guided Meditations (binaural audio) — $47', 'BONUS: DMT The God Molecule (audio + eBook) — $17', 'Masterclass: "The True Secret of the Elites" (1hr)'],
      modulesTitle: 'WHAT YOU GET: The Central System ($47 Value)',
      modules: ['The Veil Revealed', 'The Hidden Rules Of The System', 'The Awakening Sequence', 'The Infinite Game Plan'],
      guaranteeTitle: '"Remember Who You Are" Guarantee — 30 Days',
      guaranteeText: "If this book doesn't spark a genuine shift in your consciousness within 7 days, full refund in 24 hours. No questions asked.",
      finalUrgency: "Limited Time Offer. Once this first run is sold out, the price returns to $47. Consciousness is accelerating — the next cycle won't wait.",
      path1: 'Path 1: Keep playing blind, repeating cycles.',
      path2: 'Path 2: Wake up and play consciously.',
      faq: [{
        q: 'Who is this for?',
        a: "For anyone who feels the world is a game they don't understand and wants to remember how to play."
      }, {
        q: 'Do I need to be "spiritual"?',
        a: 'No. Just curiosity and the courage to question.'
      }, {
        q: 'How long to see results?',
        a: 'Most feel a shift within the first three chapters.'
      }, {
        q: 'Is it connected to religion?',
        a: 'No. It is a universal framework: science + mysticism + direct experience.'
      }],
      ps: "P.S.: Your awakening doesn't begin when you finish the book. It begins the moment you say yes."
    }
  };
  const t = content[lang];
  // Assets URLs
  const AUDIO_DMT = "https://res.cloudinary.com/dab9nhevk/video/upload/v1772470476/reseñaDMTingles_g7utk6.mp3";
  const [dmtPlaying, setDmtPlaying] = useState(false);
  const [dmtTime, setDmtTime] = useState(0);
  const [dmtDuration, setDmtDuration] = useState(0);
  const dmtRef = useRef<HTMLAudioElement>(null);

  // Optimizadas: calidad auto, formato webp, ancho máximo controlado
  const IMG_PORTADADMT = "https://res.cloudinary.com/dab9nhevk/image/upload/v1772471980/Generated_Image_bonomoleculaDMT_g0q9nc.png";
  const IMG_MOCKUP = "https://res.cloudinary.com/dab9nhevk/image/upload/q_auto,f_auto,w_600/v1772470975/Generated_Image_R_U_ready_to_play_mockup_zteork.png";
  const [dmtExpanded, setDmtExpanded] = useState(false);
  return <div className="relative z-10 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8  pt-0 pb-2 sm:pt-1 sm:pb-4 space-y-16 sm:space-y-24" data-id="element-57">

    {/* 1. Hero Section */}
    <section className="text-center space-y-3 sm:space-y-4 min-h-[85vh] flex flex-col justify-center pt-0" data-id="element-58">
    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-transparent rounded-2xl -z-10 pointer-events-none" data-id="element-59" />  
      <div className="flex justify-center w-full" data-id="element-60">
        <div className="bg-matrix/10 border border-matrix text-matrix px-20 py-0.5 rounded-full font-mono uppercase w-fit whitespace-nowrap" style={{
          fontSize: 'clamp(0.5rem, 2vw, 0.75rem)'
        }} data-id="element-61">
          {t.badge}
        </div>
      </div>

      {/* HEADLINE — controlado en desktop */}
      <h1 className="text-3xl sm:text-4xl lg:text-4xl xl:text-5xl font-serif font-bold leading-tight tracking-tight px-2 max-w-4xl mx-auto" style={{
        textShadow: '0 2px 10px rgba(0,0,0,1), 0 0 30px rgba(0,0,0,0.9)'
      }} data-id="element-62">
        <span className="text-white" data-id="element-63">
          Want to{' '}
        </span>
        <span className="text-glow-matrix animate-pulse" data-id="element-64">
          Wake Up {' '}
        </span>
        <span className="text-white" data-id="element-65">
          from the Matrix{' '}
        </span>
        <span className="text-glow-matrix animate-pulse" data-id="element-66">
          Without Losing Yourself?
        </span>
      </h1>

      {/* SUBHEADLINE — más compacta */}
      <h2 className="text-sm sm:text-base md:text-lg text-gray-300 font-serif max-w-2xl mx-auto leading-relaxed border-l-4 border-gold pl-4 italic text-left" data-id="element-67">
        {t.subheadline}
      </h2>

      {/* LEAD — más corto visualmente */}
      <p className="text-sm sm:text-base text-gray-300 max-w-xl mx-auto leading-snug px-2 bg-black/30 rounded-lg py-2" data-id="element-68">
        {t.lead}
      </p>

      {/* AUDIO + CTA visibles en primer fold */}
      <div className="py-1 sm:py-2" data-id="element-69">
        <AudioPlayer data-id="element-70" />
      </div>

    {/* BOTÓN PÍLDORA — Piece vs Player */}
    <div className="flex flex-col items-center gap-3" data-id="element-71">
      {/* Texto encima */}
      <p className="text-xs sm:text-sm text-gray-400 uppercase tracking-widest font-mono" data-id="element-72">
        Want to play as a:
      </p>

      {/* GLOW animado alrededor del botón */}
      <div className="relative w-full sm:w-auto" data-id="element-73">


        {/* Anillo pulsante verde */}
        <div className="absolute -inset-1 rounded-full animate-pulse blur-sm pointer-events-none" style={{
            background: 'linear-gradient(to right, rgba(220,38,38,0.5), rgba(37,99,235,0.5))'
          }} data-id="element-74" />
        <div className="absolute -inset-2 rounded-full animate-ping opacity-30 pointer-events-none" style={{
            background: 'linear-gradient(to right, rgba(220,38,38,0.3), rgba(37,99,235,0.3))'
          }} data-id="element-75" />
        

        {/* PÍLDORA */}
        <div className="flex items-stretch rounded-full overflow-hidden border-2 border-white/20 shadow-2xl w-full sm:w-auto" data-id="element-76">
          
          {/* Lado izquierdo — PIECE (rojo) */}
          <button onClick={() => document.getElementById('pain-section')?.scrollIntoView({
              behavior: 'smooth'
            })} className="flex-1 sm:flex-none px-6 sm:px-10 py-3 sm:py-4 bg-red-600 hover:bg-red-500 text-white font-bold uppercase tracking-wider transition-all duration-300 hover:shadow-[0_0_30px_rgba(220,38,38,0.7)] flex flex-col items-center justify-center gap-0.5" style={{
              textShadow: '0 2px 4px rgba(0,0,0,0.5)'
            }} data-id="element-77">
            <div className="flex items-center gap-2 text-base sm:text-xl" data-id="element-78">
              <span className="text-red-200 text-sm" data-id="element-79">🔴</span>
              PIECE
            </div>
            <span className="text-red-200/70 text-xs font-normal tracking-normal" data-id="element-80">
              keep reading
            </span>
          </button>

          {/* Divisor central */}
          <div className="flex items-center justify-center bg-black/80 px-3 py-4 border-x border-white/10" data-id="element-81">
            <span className="text-gray-400 text-xs font-mono" data-id="element-82">or</span>
          </div>

        {/* Lado derecho — PLAYER (azul) */}
        <button onClick={() => document.getElementById('offer-section')?.scrollIntoView({
              behavior: 'smooth'
            })} className="flex-1 sm:flex-none px-6 sm:px-10 py-3 sm:py-4 bg-blue-600 hover:bg-blue-500 text-white font-bold uppercase tracking-wider transition-all duration-300 hover:shadow-[0_0_30px_rgba(37,99,235,0.7)] flex flex-col items-center justify-center gap-0.5" style={{
              textShadow: '0 2px 4px rgba(0,0,0,0.5)'
            }} data-id="element-83">
          <div className="flex items-center gap-2 text-base sm:text-xl" data-id="element-84">
            PLAYER
            <span className="text-blue-200 text-sm" data-id="element-85">🔵</span>
          </div>
          <span className="text-blue-200/70 text-xs font-normal tracking-normal" data-id="element-86">
            Go to OFFER
          </span>
        </button>
      </div>
    </div>
    <div className="flex items-center gap-2 text-xs text-gray-400" data-id="element-87">
      <Lock size={12} data-id="element-88" />
      <span data-id="element-89">Both paths lead to awakening — choose yours</span>
    </div>    

  </div>

    
    </section>

      {/* 2. Quote Hook */}
        <section className="relative py-10 sm:py-10" data-id="element-90">

          {/* Fondo MUY transparente para ver imagen */}
          <div className="absolute inset-0 bg-black/20 backdrop-blur-[2px] rounded-2xl" data-id="element-91" />

          <div className="relative z-10 px-6 sm:px-10" data-id="element-92">

            {/* Texto principal */}
            <blockquote className="text-xl sm:text-2xl md:text-3xl font-serif text-center italic leading-relaxed max-w-3xl mx-auto mb-10" style={{
          textShadow: '0 2px 8px rgba(0,0,0,1), 0 0 20px rgba(0,0,0,0.9)'
        }} data-id="element-93">
              <span className="text-white" data-id="element-94">
                There are two types of people:{' '}
              </span>
              <span className="text-red-400" data-id="element-95">
                those who play as a Piece,{' '}
              </span>
              <span className="text-white" data-id="element-96">
                and those who realize they are{' '}
              </span>
              <span className="text-blue-400" data-id="element-97">
                holding the controller.{' '}
              </span>
              <span className="text-yellow-400 font-bold" data-id="element-98">
                Which one are you?
              </span>
            </blockquote>

            {/* DOS TIPOS — con iconos */}
            <div className="grid grid-cols-2 gap-4 sm:gap-8 max-w-2xl mx-auto" data-id="element-99">

              {/* PIECE card — narrativo */}
              <div className="flex flex-col items-center gap-3 p-4 sm:p-6 rounded-xl border border-red-500/40 bg-red-950/20 backdrop-blur-sm hover:bg-red-950/40 transition-all" data-id="element-100">
                <div className="text-3xl sm:text-4xl" data-id="element-101">♟️</div>
                <div className="text-red-400 font-bold text-sm sm:text-lg uppercase tracking-widest" data-id="element-102">
                  The Piece
                </div>
                <p className="text-gray-300 text-xs sm:text-sm text-center leading-relaxed" style={{
              textShadow: '0 1px 4px rgba(0,0,0,1)'
            }} data-id="element-103">
                  Follows the rules.<br data-id="element-104" />
                  Reacts to the board.<br data-id="element-105" />
                  Waits to be moved.
                </p>
                <div className="px-3 py-1 rounded-full bg-red-600/20 border border-red-500/30 text-red-400 text-xs font-mono" data-id="element-106">
                  😴 Still asleep
                </div>
                {/* CTA narrativo — sigue leyendo */}
                <button onClick={() => document.getElementById('pain-section')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-xs text-gray-500 hover:text-red-400 underline mt-1 transition-colors" data-id="element-107">
                  This was me... keep reading →
                </button>
              </div>

              {/* PLAYER card — compra */}
              <div className="relative flex flex-col items-center gap-3 p-4 sm:p-6 rounded-xl border border-blue-500/40 bg-blue-950/20 backdrop-blur-sm hover:bg-blue-950/40 transition-all" data-id="element-108">
                
                {/* Badge recomendado */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs px-3 py-0.5 rounded-full font-bold uppercase whitespace-nowrap" data-id="element-109">
                  ✨ This is you
                </div>

                <div className="text-3xl sm:text-4xl" data-id="element-110">🎮</div>
                <div className="text-blue-400 font-bold text-sm sm:text-lg uppercase tracking-widest" data-id="element-111">
                  The Player
                </div>
                <p className="text-gray-300 text-xs sm:text-sm text-center leading-relaxed" style={{
              textShadow: '0 1px 4px rgba(0,0,0,1)'
            }} data-id="element-112">
                  Sees the game.<br data-id="element-113" />
                  Holds the controller.<br data-id="element-114" />
                  Chooses consciously.
                </p>
                <div className="px-3 py-1 rounded-full bg-blue-600/20 border border-blue-500/30 text-blue-400 text-xs font-mono" data-id="element-115">
                  👁️ Awake
                </div>
                {/* CTA de compra */}
                <button onClick={() => document.getElementById('offer-section')?.scrollIntoView({
              behavior: 'smooth'
            })} className="mt-1 w-full py-2 px-4 bg-blue-600 hover:bg-blue-500 text-white text-xs font-bold rounded-lg uppercase tracking-wide transition-all shadow-[0_0_15px_rgba(37,99,235,0.5)]" data-id="element-116">
                  I AM THE PLAYER →
                </button>
              </div>

            </div>

          </div>    
      </section>

      {/* 3. Credibility */}
      <section className="flex flex-col gap-4 text-xs sm:text-sm md:text-base text-gray-400 border border-matrix/20 p-4 sm:p-6 rounded-lg bg-black/80" data-id="element-117">
        <div className="flex items-center gap-3" data-id="element-118">
          <div className="shrink-0 w-8 h-8 rounded-full bg-matrix/10 border border-matrix/30 flex items-center justify-center text-matrix" data-id="element-119">
            <Users size={16} data-id="element-120" />
          </div>
          <span className="leading-relaxed" data-id="element-121">{t.credibility[0]}</span>
        </div>

        <div className="flex items-center gap-3" data-id="element-122">
          <div className="shrink-0 w-8 h-8 rounded-full bg-matrix/10 border border-matrix/30 flex items-center justify-center text-matrix" data-id="element-123">
            <Globe size={16} data-id="element-124" />
          </div>
          <span className="leading-relaxed" data-id="element-125">{t.credibility[1]}</span>
        </div>

      </section>

      {/* 4. Pain Points */}
      
      <section id="pain-section" className="space-y-6 bg-gray-900/50 p-5 sm:p-8 rounded-xl border border-red-900/30" data-id="element-126">
        <div className="text-center space-y-3" data-id="element-127">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-serif text-white leading-snug" data-id="element-128">
            {t.painTitle}
          </h3>
          <p className="text-sm sm:text-base text-gray-400" data-id="element-129">{t.painSubtitle}</p>
        </div>
        <ul className="space-y-3 max-w-2xl mx-auto" data-id="element-130">
          {t.painPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-131">
              <XCircle size={18} className="text-red-500 mt-1 shrink-0" data-id="element-132" />
              <span className="text-sm sm:text-lg leading-relaxed" data-id="element-133">{point}</span>
            </li>)}
        </ul>
      </section>

    {/* 5. Urgency — expandida */}
    <section className="space-y-0" data-id="element-134">

  {/* Bloque 1 — texto que ya tenías */}
  <div className="text-center space-y-4 py-8 sm:py-10 px-4 sm:px-6 
    rounded-t-2xl border border-matrix/30 bg-black" data-id="element-135">
    <h3 className="text-xl sm:text-3xl md:text-4xl font-serif 
      text-matrix text-glow-matrix leading-snug" data-id="element-136">
      {t.urgencyTitle}
    </h3>
    <p className="text-sm sm:text-xl text-gray-300 max-w-3xl 
      mx-auto leading-relaxed" data-id="element-137">
      {t.urgencyText}
    </p>
  </div>

  {/* Bloque 2 — nuevo: colliding + viñetas */}
  <div className="bg-gray-900/60 border-x border-matrix/30 px-6 py-8 space-y-6" data-id="element-138">

    <p className="text-sm sm:text-base text-gray-300 leading-relaxed" data-id="element-139">
      Technology, energy, and consciousness are colliding —{' '}
      <span className="text-white font-semibold" data-id="element-140">
        but most people are still hypnotized by the simulation.
      </span>
    </p>

    <div className="space-y-1" data-id="element-141">
      <p className="text-matrix font-mono text-xs uppercase tracking-widest mb-4" data-id="element-142">
        ◈ Here's why this moment matters:
      </p>

      {[{
            icon: <Sparkles size={20} className="text-matrix shrink-0 mt-0.5" data-id="element-143" />,
            text: 'Quantum science now confirms what the mystics always knew:',
            highlight: 'reality is code.'
          }, {
            icon: <TrendingUp size={20} className="text-matrix shrink-0 mt-0.5" data-id="element-144" />,
            text: 'The old systems built on fear and hierarchy',
            highlight: 'are crumbling.'
          }, {
            icon: <Zap size={20} className="text-matrix shrink-0 mt-0.5" data-id="element-145" />,
            text: 'Those who learn to play consciously',
            highlight: 'are rewriting the collective game.'
          }].map((item, i) => <div key={i} className="flex items-start gap-3 
          p-3 rounded-lg border border-matrix/10 
          bg-black/30 hover:border-matrix/30 transition-all" data-id="element-146">
          <span className="text-matrix text-lg shrink-0 mt-0.5 
            leading-none" data-id="element-147">
            {item.icon}
          </span>
          <p className="text-sm sm:text-base text-gray-300 leading-snug" data-id="element-148">
            {item.text}{' '}
            <span className="text-matrix font-semibold" data-id="element-149">
              {item.highlight}
            </span>
          </p>
        </div>)}
    </div>

  </div>

  {/* Bloque 3 — cierre: window won't stay open */}
  <div className="bg-black border border-t-0 border-matrix/30 
    rounded-b-2xl px-6 py-6 sm:py-8" data-id="element-150">
    <div className="flex items-start gap-4 max-w-3xl mx-auto" data-id="element-151">
      <span className="text-matrix text-2xl shrink-0 mt-1" data-id="element-152">⧖</span>
      <p className="text-sm sm:text-base text-gray-200 leading-relaxed italic" data-id="element-153">
        This window won't stay open forever. Every soul that remembers{' '}
        <span className="text-matrix font-semibold" data-id="element-154">
          shifts the field
        </span>{' '}
        — but delay, and the code closes back around you.
      </p>
    </div>
  </div>

    </section>

    {/* 6. Author — WARNING + Story + Imagine */}
    <section className="space-y-0" data-id="element-155">

  {/* WARNING banner */}
  <div className="bg-red-950/80 border border-red-500/60 rounded-t-2xl px-6 py-4 flex items-start gap-3" data-id="element-156">
    <span className="text-red-400 font-black text-lg shrink-0 mt-0.5" data-id="element-157">⚠</span>
    <div data-id="element-158">
      <p className="text-red-400 font-black uppercase tracking-widest text-sm mb-1" data-id="element-159">
        Warning
      </p>
      <p className="text-red-200/90 text-sm sm:text-base leading-relaxed" data-id="element-160">
        What you're about to read will challenge everything you were taught about reality.
      </p>
    </div>
  </div>

  {/* Author card conectada al WARNING */}
  <div className="bg-gray-900/90 border border-gray-700/60 border-t-0 rounded-b-2xl px-6 py-8 space-y-6" data-id="element-161">

    {/* From / Location — estilo terminal */}
    <div className="font-mono text-xs sm:text-sm space-y-1 text-gray-400" data-id="element-162">
      <p data-id="element-163">
        <span className="text-matrix" data-id="element-164">From:</span>{' '}
        <span className="text-white font-bold" data-id="element-165">Gabriel Beltrán</span>
      </p>
      <p data-id="element-166">
        <span className="text-matrix" data-id="element-167">Location:</span>{' '}
        <span className="text-gray-300" data-id="element-168">Earth, Level 3 Density</span>
      </p>
    </div>

    {/* Historia con línea lateral verde */}
    <div className="space-y-4 text-sm sm:text-base text-gray-300 leading-relaxed border-l-2 border-matrix/40 pl-4" data-id="element-169">
      <p data-id="element-170">
        I once lived asleep inside the system — working, achieving, repeating
        the same patterns. Then one day,{' '}
        <span className="text-white font-semibold" data-id="element-171">everything cracked.</span>
      </p>
      <p data-id="element-172">
        I realized my life wasn't random.{' '}
        <span className="text-matrix font-semibold" data-id="element-173">It was scripted.</span>{' '}
        But instead of panic, I felt clarity.{' '}
        <em className="text-gray-200" data-id="element-174">
          What if this was a game — and I could remember the rules?
        </em>
      </p>
      <p data-id="element-175">
        Years of research, deep meditations, and encounters with the molecule
        that reveals the code{' '}
        <span className="text-matrix font-semibold" data-id="element-176">(DMT)</span>{' '}
        uncovered the hidden architecture of reality. That journey became{' '}
        <span className="text-white font-bold italic" data-id="element-177">Are You Ready To Play?</span>{' '}
        — a guide for souls who are done obeying fear and ready to create consciously.
      </p>
    </div>

    {/* Divider + Imagine this */}
    <div className="border-t border-gray-700/50 pt-6" data-id="element-178">

      <p className="text-matrix font-mono text-xs uppercase tracking-widest mb-4" data-id="element-179">
        ◈ Before I reveal what's inside — imagine this:
      </p>

      <div className="space-y-3" data-id="element-180">
        {[{
              icon: <Sunrise size={20} className="text-matrix shrink-0 mt-1" data-id="element-181" />,
              text: <>You wake up tomorrow <span className="text-matrix font-semibold" data-id="element-182">knowing exactly why you're here.</span></>
            }, {
              icon: <Compass size={20} className="text-matrix shrink-0 mt-1" data-id="element-183" />,
              text: <>You stop chasing meaning — because you <span className="text-matrix font-semibold" data-id="element-184">ARE meaning.</span></>
            }, {
              icon: <Waves size={20} className="text-matrix shrink-0 mt-1" data-id="element-185" />,
              text: <><span className="text-matrix font-semibold" data-id="element-186">Fear dissolves.</span> Synchronicities <span className="text-matrix font-semibold" data-id="element-187">multiply.</span></>
            }, {
              icon: <HeartPulse size={20} className="text-matrix shrink-0 mt-1" data-id="element-188" />,
              text: <>Life feels <span className="text-matrix font-semibold" data-id="element-189">alive again.</span></>
            }].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-190">
            {item.icon}
            <p className="text-gray-200 text-sm sm:text-base leading-snug" data-id="element-191">
              {item.text}
            </p>
          </div>)}
      </div>

    </div>
  </div>
    </section>

    {/* 7. Oferta Digital — solo $17 */}
    <section id="offer-section" className="space-y-0" data-id="element-192">

  {/* Header de la card */}
  <div className="bg-matrix/10 border border-matrix/40 rounded-t-2xl 
    px-6 py-3 flex items-center justify-between" data-id="element-193">
    <div className="flex items-center gap-2" data-id="element-194">
      <span className="text-matrix text-xs font-mono uppercase 
        tracking-widest" data-id="element-195">
        ⬇ Digital Edition
      </span>
    </div>
    {/* Estrellas */}
    <div className="flex gap-1" data-id="element-196">
      {[1, 2, 3, 4, 5].map(s => <Star key={s} size={12} className="text-matrix" fill="currentColor" data-id="element-197" />)}
    </div>
  </div>

  {/* Body principal */}
  <div className="bg-gray-900/80 border-x border-gray-700/50 px-6 py-8 
    space-y-6" data-id="element-198">

    {/* Imagen portada + precio */}
    <div className="flex flex-col sm:flex-row gap-6 items-center" data-id="element-199">

      {/* Imagen portada */}
      <div className="w-64 sm:w-72 shrink-0" data-id="element-200">
        <div className="aspect-[4/3] bg-gray-800 rounded-xl border 
          border-matrix/30 relative overflow-hidden flex items-center 
          justify-center" data-id="element-201">
          {/* Reemplazar con <img src="..." /> cuando tengas imagen real */}
          <img src={IMG_MOCKUP} alt="Are You Ready To Play - Book Mockup" className="w-full h-full object-cover rounded-xl" loading="lazy" data-id="element-202" />
          <div className="absolute inset-0 bg-gradient-to-t 
            from-black/60 via-transparent to-transparent" data-id="element-203" />
        </div>
      </div>

      {/* Precio y features */}
      <div className="flex-1 space-y-4" data-id="element-204">

        {/* Precio */}
        <div className="space-y-1" data-id="element-205">
          <div className="flex items-baseline gap-3" data-id="element-206">
            <span className="text-5xl sm:text-6xl font-bold text-matrix 
              text-glow-matrix" data-id="element-207">
              $17
            </span>
            <span className="text-xl text-gray-500 line-through" data-id="element-208">$47</span>
          </div>
          <p className="text-matrix font-mono text-xs uppercase 
            tracking-widest" data-id="element-209">
            Instant Download
          </p>
        </div>

        {/* Features */}
        <ul className="space-y-2" data-id="element-210">
          {[{
                icon: <Check size={14} data-id="element-211" />,
                text: 'Instant digital access'
              }, {
                icon: <Check size={14} data-id="element-212" />,
                text: 'Read on any device'
              }, {
                icon: <Headphones size={14} data-id="element-213" />,
                text: 'Full audiobook included (1:49:47)'
              }].map((feat, i) => <li key={i} className="flex items-center gap-3 
              text-sm text-gray-300" data-id="element-214">
              <span className="text-matrix shrink-0" data-id="element-215">{feat.icon}</span>
              {feat.text}
            </li>)}
        </ul>

      </div>
    </div>

    {/* FREE BONUS card */}
    <div className="rounded-xl border border-matrix/30 bg-black/50 p-4 
      sm:p-5 space-y-3" data-id="element-216">

      {/* Badge bonus */}
      <div className="flex items-center gap-2" data-id="element-217">
        <Headphones size={14} className="text-matrix" data-id="element-218" />
        <span className="text-matrix font-mono text-xs uppercase 
          tracking-widest font-bold" data-id="element-219">
          🎁 Free Bonus
        </span>
      </div>

      <div className="flex gap-4 items-start" data-id="element-220">

        {/* Imagen bonus */}
        <div className="w-32 sm:w-40 shrink-0" data-id="element-221">
          <div className="aspect-square bg-gray-800 rounded-lg border 
            border-matrix/20 flex items-center justify-center 
            text-gray-600 text-xs text-center" data-id="element-222">
            {/* Reemplazar con <img src="..." /> */}
              <img src={IMG_PORTADADMT} alt="DMT: The Spirit Molecule" className="w-full h-full object-cover rounded-lg border 
                  border-matrix/20" loading="lazy" data-id="element-223" />
          </div>
        </div>

        {/* Texto bonus */}
        <div className="space-y-1 flex-1" data-id="element-224">
          <h4 className="text-white font-bold text-sm sm:text-base" data-id="element-225">
            DMT: The Spirit Molecule
          </h4>
          <p className="text-gray-400 text-xs leading-relaxed" data-id="element-226">
            A Journey to Everything
          </p>
          <div className="flex items-center gap-2 text-xs text-gray-400" data-id="element-227">
            <Headphones size={10} className="text-matrix" data-id="element-228" />
            <span data-id="element-229">Audiobook + Digital Book</span>
          </div>
          <div className="inline-block bg-matrix/10 border 
            border-matrix/30 text-matrix text-xs px-2 py-0.5 rounded-full 
            font-mono" data-id="element-230">
            ($39.97 Value)
          </div>

        </div>

      </div>

      {/* Audio player DMT */}
      <div className="rounded-lg bg-black/60 border border-matrix/20 p-3" data-id="element-231">
        
        <audio ref={dmtRef} src={AUDIO_DMT} preload="metadata" onTimeUpdate={() => setDmtTime(dmtRef.current?.currentTime || 0)} onLoadedMetadata={() => setDmtDuration(dmtRef.current?.duration || 0)} onEnded={() => setDmtPlaying(false)} data-id="element-232" />

        <div className="flex items-center gap-3" data-id="element-233">
          <button onClick={() => {
                if (!dmtRef.current) return;
                if (dmtPlaying) {
                  dmtRef.current.pause();
                } else {
                  dmtRef.current.play();
                }
                setDmtPlaying(!dmtPlaying);
              }} className="w-8 h-8 rounded-full bg-matrix/20 border border-matrix/40
              flex items-center justify-center text-matrix 
              hover:bg-matrix/30 transition-all shrink-0" data-id="element-234">
            {dmtPlaying ? <Pause size={12} data-id="element-235" /> : <Play size={12} className="ml-0.5" data-id="element-236" />}
          </button>

          <div className="flex-1 space-y-1" data-id="element-237">
            <p className="text-matrix text-xs font-mono" data-id="element-238">
              DMT: The Spirit Molecule — Intro
            </p>
            <div className="w-full h-1 bg-gray-700 rounded-full cursor-pointer" onClick={e => {
                  if (!dmtRef.current || !dmtDuration) return;
                  const rect = e.currentTarget.getBoundingClientRect();
                  dmtRef.current.currentTime = (e.clientX - rect.left) / rect.width * dmtDuration;
                }} data-id="element-239">
              <div className="h-1 bg-matrix rounded-full transition-all duration-100" style={{
                    width: `${dmtDuration > 0 ? dmtTime / dmtDuration * 100 : 0}%`
                  }} data-id="element-240" />
            </div>
            <div className="flex justify-between text-gray-600 
              text-xs font-mono" data-id="element-241">
              <span data-id="element-242">
                {Math.floor(dmtTime / 60)}:
                {Math.floor(dmtTime % 60).toString().padStart(2, '0')}
              </span>
              <span data-id="element-243">
                {Math.floor(dmtDuration / 60)}:
                {Math.floor(dmtDuration % 60).toString().padStart(2, '0')}
              </span>
            </div>
          </div>
        </div>
      </div>

        {/* Read More / Less */}
        <button onClick={() => setDmtExpanded(!dmtExpanded)} className="flex items-center gap-2 text-matrix text-xs font-mono 
            uppercase tracking-widest hover:text-matrix/70 transition-colors 
            w-full justify-center py-1" data-id="element-244">
          {dmtExpanded ? <>Read Less <ChevronUp size={14} data-id="element-245" /></> : <>Read More <ChevronDown size={14} data-id="element-246" /></>}
        </button>

        {/* Contenido expandible */}
        {dmtExpanded && <div className="space-y-4 text-xs sm:text-sm text-gray-300 
            leading-relaxed border-t border-matrix/20 pt-4 animate-fade-in" data-id="element-247">

            <p className="text-gray-200 italic" data-id="element-248">
              Discover the molecule that bridges science and spirit.
            </p>

            <p className="text-gray-300 leading-relaxed" data-id="element-249">
              <span className="text-white font-semibold" data-id="element-250">
                DMT: The Spirit Molecule
              </span>{' '}
              is a profound exploration of consciousness, perception, and the hidden 
              dimensions of reality. Written in lyrical, thought-provoking prose, 
              this book blends scientific insight with spiritual depth, guiding the 
              reader through one of the most mysterious substances in existence —{' '}
              <span className="text-matrix font-semibold" data-id="element-251">
                N,N-Dimethyltryptamine (DMT).
              </span>
            </p>

            <div className="space-y-2" data-id="element-252">
              <p className="text-matrix font-mono text-xs uppercase tracking-widest" data-id="element-253">
                ◈ Through its pages, you will uncover:
              </p>
              {['The scientific story behind DMT and its natural presence in the human brain', 'The ancient Amazonian wisdom of Ayahuasca and its connection to the spirit world', 'The role of the pineal gland as a possible gateway to higher consciousness', 'The parallels between quantum physics and mystical experience', 'The transformative process of death, rebirth, and integration revealed through DMT'].map((point, i) => <div key={i} className="flex items-start gap-2" data-id="element-254">
                  <span className="text-matrix shrink-0 mt-0.5" data-id="element-255">•</span>
                  <p className="text-gray-300" data-id="element-256">{point}</p>
                </div>)}
            </div>

            <p className="text-gray-300 leading-relaxed" data-id="element-257">
              Each chapter merges modern neuroscience with timeless spiritual 
              understanding, revealing that the boundaries between the physical 
              and the divine are{' '}
              <span className="text-matrix font-semibold" data-id="element-258">
                far thinner than we imagine.
              </span>
            </p>

            <p className="text-white italic font-serif text-sm sm:text-base" data-id="element-259">
              "This book is not about escaping reality — it's about remembering 
              what reality truly is."
            </p>

            {/* Details */}
            <div className="bg-black/40 rounded-lg border border-matrix/20 
              p-3 space-y-1 font-mono text-xs" data-id="element-260">
              <p className="text-matrix uppercase tracking-widest mb-2" data-id="element-261">
                Details:
              </p>
              {[{
                label: 'Format',
                value: 'Digital'
              }, {
                label: 'Length',
                value: '92 pages'
              }, {
                label: 'Genre',
                value: 'Spirituality, Consciousness, Science & Philosophy'
              }].map((d, i) => <div key={i} className="flex gap-2" data-id="element-262">
                  <span className="text-gray-500" data-id="element-263">{d.label}:</span>
                  <span className="text-gray-300" data-id="element-264">{d.value}</span>
                </div>)}
            </div>

          </div>}
    </div>

  </div>

  {/* CTA button */}
  <div className="bg-black border-x border-b border-gray-700/50 
    rounded-b-2xl px-6 py-6" data-id="element-265">
    <Button variant="gold" className="w-full text-base sm:text-xl py-4 sm:py-6 
        shadow-[0_0_30px_rgba(255,215,0,0.3)]" onClick={() => {
          // 1. Facebook Pixel — AddToCart event
          // window.fbq('track', 'AddToCart', {
          //   content_name: 'Are You Ready To Play',
          //   content_type: 'product',
          //   value: 17.00,
          //   currency: 'USD'
          // });

          // 2. Redirigir a Shopify checkout
          // window.location.href = 'TU_URL_SHOPIFY_AQUI';
        }} data-id="element-266">
      GET DIGITAL EDITION
    </Button>
    <div className="flex items-center justify-center gap-2 mt-3 
      text-xs text-gray-500" data-id="element-267">
      <Lock size={10} data-id="element-268" />
      <span data-id="element-269">Secure checkout — 30-Day Money Back Guarantee</span>
    </div>
  </div>
    </section>


      {/* 8. Pack Best Seller 
       <section className="relative z-20">
        <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-500 to-gold rounded-2xl blur opacity-30"></div>
        <div className="relative bg-black border-2 border-gold rounded-2xl p-5 sm:p-8 md:p-10 shadow-2xl">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-black font-bold px-4 py-1.5 rounded-full text-xs sm:text-sm flex items-center gap-1 whitespace-nowrap">
            <Star size={12} fill="black" /> {t.packTitle} <Star size={12} fill="black" />
          </div>
           <div className="mt-6 text-center mb-6">
            <div className="flex justify-center items-baseline gap-3">
              <span className="text-4xl sm:text-6xl font-bold text-gold text-glow-gold">
                {t.packPriceNew}
              </span>
              <span className="text-xl text-gray-500 line-through">{t.packPriceOld}</span>
            </div>
          </div>
           <div className="space-y-3 mb-6">
            {t.packFeatures.map((feat, i) =>
              <div key={i} className="flex items-start gap-3 p-3 rounded bg-gray-900/50 border border-gray-800">
                <div className="mt-0.5 text-gold shrink-0"><Check size={16} /></div>
                <span className="text-gray-200 text-xs sm:text-sm leading-relaxed">{feat}</span>
              </div>
            )}
          </div>
           <Button variant="gold" className="w-full text-base sm:text-xl py-4 sm:py-6">
            {t.ctaGold}
          </Button>
        </div>
       </section>*/}


      {/* 9. What You Get */}
      <section className="bg-gray-900/30 border border-matrix/20 rounded-2xl p-5 sm:p-8" data-id="element-270">
        <h3 className="text-lg sm:text-2xl font-serif text-center text-white mb-6" data-id="element-271">
          {t.modulesTitle}
        </h3>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-272">
          {t.modules.map((mod, i) => <div key={i} className="flex items-center gap-3 p-3 sm:p-4 bg-black/40 rounded-lg border border-gray-800" data-id="element-273">
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-matrix/10 flex items-center justify-center text-matrix font-mono font-bold text-sm shrink-0" data-id="element-274">
                0{i + 1}
              </div>
              <span className="text-sm sm:text-lg text-gray-200" data-id="element-275">{mod}</span>
            </div>)}
        </div>
      </section>

      {/* 10. Text Testimonials */}
      <section className="space-y-4" data-id="element-276">
        {[{
        text: 'Sentí como si estuviera recordando algo ancestral.',
        author: 'E.M.'
      }, {
        text: 'Cada párrafo desmanteló una creencia que no sabía que era programación.',
        author: 'S.T.'
      }, {
        text: 'Dejé de luchar contra la vida y comencé a jugar con ella — y todo cambió.',
        author: 'L.R.'
      }].map((test, i) => <div key={i} className="bg-gray-900/50 p-4 sm:p-6 rounded-xl border border-gray-800" data-id="element-277">
            <div className="flex text-gold mb-3 gap-1" data-id="element-278">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} size={12} fill="currentColor" data-id="element-279" />)}
            </div>
            <p className="text-sm sm:text-base text-gray-300 italic mb-3" data-id="element-280">"{test.text}"</p>
            <div className="text-xs sm:text-sm font-bold text-white text-right" data-id="element-281">— {test.author}</div>
          </div>)}
      </section>

      {/* 11. Guarantee */}
      <section className="bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-12 text-center max-w-3xl mx-auto" data-id="element-282">
        <div className="inline-flex p-3 sm:p-4 rounded-full bg-gold/10 text-gold mb-4" data-id="element-283">
          <Shield size={36} data-id="element-284" />
        </div>
        <h3 className="text-xl sm:text-2xl md:text-3xl font-serif text-white mb-3" data-id="element-285">
          {t.guaranteeTitle}
        </h3>
        <p className="text-sm sm:text-base text-gray-400 mb-4 leading-relaxed" data-id="element-286">{t.guaranteeText}</p>
        <div className="text-xs text-gray-500 font-mono" data-id="element-287">support@areyoureadytoplay.com</div>
      </section>


      {/* 12. Final CTA + FAQ */}
      <section className="space-y-12" data-id="element-288">
        <div className="text-center space-y-4" data-id="element-289">
          <Button variant="gold" className="w-full sm:w-auto text-lg sm:text-2xl px-8 sm:px-16 py-5 sm:py-8 shadow-[0_0_40px_rgba(255,215,0,0.3)] animate-pulse" data-id="element-290">
            {t.ctaGold}
          </Button>
          <p className="text-xs text-gray-500" data-id="element-291">30-Day Money Back Guarantee</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-4" data-id="element-292">
          <h3 className="text-xl sm:text-2xl font-serif text-center text-white mb-6" data-id="element-293">F.A.Q.</h3>
          {t.faq.map((item, i) => <div key={i} className="border-b border-gray-800 pb-4" data-id="element-294">
              <h4 className="text-sm sm:text-lg font-bold text-white mb-2 flex items-start gap-2" data-id="element-295">
                <span className="text-matrix shrink-0" data-id="element-296">Q:</span> {item.q}
              </h4>
              <p className="text-xs sm:text-sm text-gray-400 pl-6 leading-relaxed" data-id="element-297">
                <span className="text-gray-600 font-bold mr-2" data-id="element-298">A:</span>{item.a}
              </p>
            </div>)}
        </div>
      </section>

      {/* 13. Footer */}
      <footer className="border-t border-gray-900 pt-8 pb-6 text-center space-y-6" data-id="element-299">
        <div className="max-w-2xl mx-auto bg-gray-900/50 p-4 sm:p-6 rounded-lg border border-gray-800" data-id="element-300">
          <p className="text-sm sm:text-lg text-white font-serif italic" data-id="element-301">{t.ps}</p>
        </div>
        <div className="text-xs text-gray-600 space-y-2" data-id="element-302">
          <p data-id="element-303">© 2026 - ixanstudio.com</p>
          <p data-id="element-304">support@areyoureadytoplay.com</p>
          <div className="flex justify-center gap-4" data-id="element-305">
            <span className="hover:text-gray-400 cursor-pointer" data-id="element-306">Terms</span>
            <span className="hover:text-gray-400 cursor-pointer" data-id="element-307">Refunds</span>
            <span className="hover:text-gray-400 cursor-pointer" data-id="element-308">Privacy</span>
          </div>
        </div>
      </footer>
    </div>;
}